import { useFetchUserInfo } from '@/hooks/user-setting-hooks';
import { Modal } from 'antd';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { history } from 'umi';

const PASSWORD_EXPIRY_WARN_DAYS = 83;
const PASSWORD_EXPIRY_FORCE_DAYS = 90;
const STORAGE_KEY = 'password_expiry_reminded_date';
const DISMISS_KEY = 'password_expiry_dismissed';

export default function PasswordExpiryChecker() {
  const { data: userInfo, loading } = useFetchUserInfo();
  const [showModal, setShowModal] = useState(false);
  const [hasChecked, setHasChecked] = useState(false);

  useEffect(() => {
    if (loading || !userInfo?.id || hasChecked) return;

    const { pwd_update_time } = userInfo;

    if (!pwd_update_time) {
      history.push('/reset-password?force=1');
      setHasChecked(true);
      return;
    }

    const isMilliseconds = pwd_update_time.toString().length >= 13;
    const timestamp = isMilliseconds ? pwd_update_time : pwd_update_time * 1000;
    
    const updateDate = dayjs(timestamp);
    const today = dayjs();
    const daysSinceUpdate = today.diff(updateDate, 'day');

    if (daysSinceUpdate >= PASSWORD_EXPIRY_FORCE_DAYS) {
      history.push('/reset-password?force=1');
    } else if (daysSinceUpdate >= PASSWORD_EXPIRY_WARN_DAYS) {
      const dismissed = localStorage.getItem(DISMISS_KEY);
      const lastRemindedDate = localStorage.getItem(STORAGE_KEY);
      const todayStr = today.format('YYYY-MM-DD');

      if (!dismissed && lastRemindedDate !== todayStr) {
        setShowModal(true);
      }
    }

    setHasChecked(true);
  }, [userInfo, loading, hasChecked]);

  const handleGoUpdate = () => {
    setShowModal(false);
    localStorage.setItem(STORAGE_KEY, dayjs().format('YYYY-MM-DD'));
    history.push('/reset-password');
  };

  const handleDismiss = () => {
    setShowModal(false);
    localStorage.setItem(DISMISS_KEY, 'true');
  };

  const handleCancel = () => {
    setShowModal(false);
    localStorage.setItem(STORAGE_KEY, dayjs().format('YYYY-MM-DD'));
  };

  return (
    <Modal
      title="密码即将过期"
      open={showModal}
      footer={null}
      closable={false}
    >
      <p className="text-gray-700 mb-4">密码即将过期，请尽快修改</p>
      <div className="flex justify-end gap-2">
        <button
          onClick={handleCancel}
          className="px-4 py-2 text-gray-600 hover:bg-gray-100 rounded-md transition-colors"
        >
          取消
        </button>
        <button
          onClick={handleDismiss}
          className="px-4 py-2 text-gray-600 hover:bg-gray-100 rounded-md transition-colors"
        >
          不再提醒
        </button>
        <button
          onClick={handleGoUpdate}
          className="px-4 py-2 bg-blue-600 text-white hover:bg-blue-700 rounded-md transition-colors"
        >
          前往修改
        </button>
      </div>
    </Modal>
  );
}